import React from 'react';
import type { NextPage } from 'next';

import Layout from '@/components/Layout';
import PerformanceBenchmark from '@/containers/resources/PerformanceBenchmark';

const PartnerPublication: NextPage = () => (
  <Layout
    title="Performance Benchmarking of AIFs"
    url="resources/performance-aifs"
    description=""
  >
    <PerformanceBenchmark />
  </Layout>
);
export default PartnerPublication;
